<header>
  <img [src]="imgBanner()" alt="" />
</header>
